if (!customElements.get("section-showcase")) {
    customElements.define(
      "section-showcase",
      class ActivityPopup extends HTMLElement {
      constructor() {
        super();
        this.init();
      }

      init() {
        const _this = this;
        let openBtns = Array.from(this.querySelectorAll(".icon-mask-open"));
        let closeBtns = Array.from(this.querySelectorAll(".showcase-icon-close"));
        let showcaseRightBox = Array.from(
          this.querySelectorAll(".showcase-right")
        );
    
        openBtns.forEach((el, index) => {
          el.onclick = () => {
            let rightBox = showcaseRightBox[index];
            rightBox.classList.add("active");
            $(showcaseRightBox).not(rightBox).removeClass("active");
          };
        });
        closeBtns.forEach((el,index)=>{
            el.onclick=()=>{
              let rightBox = showcaseRightBox[index];
                rightBox.classList.remove('active')
            }
        })
      }
    }
  );
}
